import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getExpenseCategory } from "../../../ApiService/ApiService";
import AddExpenseCategory from "./AddExpenseCategory";
import ExpenseCategoryTable from "./ExpenseCategoryTable";
import { Add } from "@mui/icons-material";

function ExpenseCategorySection() {
  const [expenseCategory, setExpenseCategory] = useState({});
  const [showAddExpenseCategory, setShowAddExpenseCategory] = useState(false);
  const [loading, setLoading] = useState(false);
  const schoolId = parseInt(sessionStorage.getItem("schoolId"));

  useEffect(() => {
    fetchExpenseCategory();
  }, []);

  const fetchExpenseCategory = async () => {
    try {
      setLoading(true);
      const response = await getExpenseCategory(schoolId);
      setExpenseCategory(response?.data);
    } catch (err) {
      console.error("Error fetching expense category:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderMainContent = () => {
    if (showAddExpenseCategory) {
      return (
        <AddExpenseCategory
          fetchExpenseCategory={fetchExpenseCategory}
          setShowAddExpenseCategory={setShowAddExpenseCategory}
        />
      );
    } else {
      return (
        <ExpenseCategoryTable
          expenseCategory={expenseCategory}
          fetchExpenseCategory={fetchExpenseCategory}
        />
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddExpenseCategory ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{
            fontWeight: 600,
            fontSize: 22,
            fontFamily: "Barlow, sans-serif",
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Expenses Category
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddExpenseCategory(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Expense Category
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default ExpenseCategorySection;
